// Presentation of exact revision identity. These labels confer no authority.
export function reviewVariantLabel(context, jobId, session) {
  if (!context || context.schema !== 'EspDefaultContext.v1' || context.job_id !== jobId
    || context.revision !== session?.revision || context.revision_digest !== session?.revision_digest
    || !/^[a-f0-9]{64}$/.test(context.variant?.profile_digest || '')
    || !context.variant?.sub_brand_id || !context.variant?.variant_id) return null;
  return context.variant.sub_brand_id + ' · ' + context.variant.variant_id;
}

export function RwVariantIdentity({ jobId, session, isLive }) {
  const [context, setContext] = React.useState(null);
  React.useEffect(() => {
    let active = true;
    setContext(null);
    if (isLive && session?.revision_digest && window.GooseAPI?.espDefaultContext) {
      window.GooseAPI.espDefaultContext(jobId, session.revision, session.revision_digest)
        .then(value => { if (active) setContext(value); }).catch(() => { if (active) setContext(null); });
    }
    return () => { active = false; };
  }, [jobId, session?.revision, session?.revision_digest, isLive]);
  const label = reviewVariantLabel(context, jobId, session);
  return <span className={'w-variant' + (label ? '' : ' unlinked')} data-variant-identity={label ? 'verified' : 'unlinked'}
    title={label ? 'Pinned same-workspace variant profile · ' + context.variant.profile_digest : 'No verified variant identity is linked to this revision.'}>
    {label || 'Variant not linked'}
  </span>;
}

export function RwRevisionDetails({ session, capabilities = [] }) {
  if (!session) return null;
  return <details className="w-revision-details">
    <summary aria-label="Revision and evidence details">{session.revision} · Details</summary>
    <div className="w-revision-popover">
      <b>Current saved revision</b>
      <span data-session-revision={session.revision}>{session.revision}</span>
      <code>{session.revision_digest}</code>
      <span data-session-authority={session.authority_mode || 'unknown'}>Authority: {session.authority_mode || 'not recorded'}</span>
      <span data-session-approval={session.approval_state || 'unknown'}>Approval: {session.approval_state || 'not recorded'}</span>
      {!!capabilities.length && <span data-session-capabilities="limited">Unavailable for this revision: {capabilities.join(' · ')}</span>}
    </div>
  </details>;
}

export function reviewPreSendActions(isLive, carried, demo) {
  return isLive ? [] : (Array.isArray(carried) ? carried : Array.isArray(demo) ? demo : []).map(action => ({ ...action }));
}

export function reviewAnchorLabel(block) {
  return !block ? 'No region selected' : block.identity !== 'authored' ? 'derived overlay'
    : (block.anchor_attr || 'data-region') + '="' + block.id + '"';
}

export function RwWorkspaceNotices({ children }) {
  const rows = React.Children.toArray(children).filter(Boolean);
  if (!rows.length) return null;
  return <React.Fragment>{rows[0]}{rows.length > 1 && <details className="w-status-details"><summary>{rows.length - 1} additional workspace note{rows.length === 2 ? '' : 's'}</summary>{rows.slice(1)}</details>}</React.Fragment>;
}
